<div class="row">
  <div class="col-12 col-xl-6 mb-3">
    <div class="card h-100">
      <div class="card-body">
        <h4 class="header-title">
          {{ "channel.channelWebchat.embedTitle" | translate }}
        </h4>
        <p class="text-muted mb-3">
          {{ "channel.channelWebchat.embedDescription" | translate }}
        </p>

        <pre class="bg-light rounded p-2 mb-2" style="white-space: pre-wrap; word-break: break-all;"><code>{{ embedCode }}</code></pre>

        <button class="btn btn-primary" (click)="copyEmbedCode()">
          <i class="ri-file-copy-line"></i>
          {{ "channel.channelWebchat.copyEmbed" | translate }}
        </button>
      </div>
    </div>
  </div>

  <div class="col-12 col-xl-6 mb-3">
    <div class="card h-100">
      <div class="card-body">
        <h4 class="header-title">
          {{ "channel.channelWebchat.domainsTitle" | translate }}
        </h4>
        <p class="text-muted mb-3">
          {{ "channel.channelWebchat.domainsDescription" | translate }}
        </p>

        <div class="d-flex gap-2 mb-3">
          <input
            class="form-control"
            [(ngModel)]="newDomain"
            [placeholder]="'channel.channelWebchat.domainPlaceholder' | translate"
            (keyup.enter)="addDomain()"
          />
          <button class="btn btn-soft-primary" (click)="addDomain()" [disabled]="loading">
            <i class="ri-add-line"></i>
            {{ "channel.channelWebchat.addDomain" | translate }}
          </button>
        </div>

        @if (domains.length === 0) {
          <p class="text-muted mb-0">
            <i class="ri-information-line"></i>
            {{ "channel.channelWebchat.noDomains" | translate }}
          </p>
        } @else {
          <div class="d-flex gap-2 flex-wrap">
            @for (domain of domains; track domain) {
              <span class="badge bg-soft-primary text-primary font-14 py-1 px-2">
                {{ domain }}
                <a href="javascript:void(0);" class="text-danger ms-1" (click)="removeDomain(domain)">
                  <i class="ri-close-line"></i>
                </a>
              </span>
            }
          </div>
        }
      </div>
    </div>
  </div>
</div>
